class SkinAssistant extends HTMLElement {
  connectedCallback() {
    this.d = this.dataset;
    this.$ = (s) => this.querySelector(s);
    this.demo = [];
    try { this.demo = JSON.parse(this.$('[data-demo-products]')?.textContent || '[]'); } catch (e) {}
    this.chats = this.load();
    this.current = null;
    this.side = this.$('[data-side]');
    this.thread = this.$('[data-thread]');
    this.input = this.$('[data-input]');

    this.$('[data-form]').addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
    this.input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.send(); } });
    this.input.addEventListener('input', () => { this.input.style.height = 'auto'; this.input.style.height = this.input.scrollHeight + 'px'; });
    this.querySelectorAll('[data-prompt]').forEach((b) => b.addEventListener('click', () => this.send(b.dataset.prompt)));
    this.querySelectorAll('[data-new]').forEach((b) => b.addEventListener('click', () => { this.newChat(); this.panel(false); }));
    this.$('[data-reset]').addEventListener('click', () => { this.chats = []; this.save(); this.newChat(); this.panel(false); });
    this.$('[data-open-history]').addEventListener('click', () => this.panel(true));
    this.querySelectorAll('[data-close-history]').forEach((b) => b.addEventListener('click', () => this.panel(false)));
    this.newChat();
    /* Question handed over from the homepage: /pages/...?q=... is sent once, then removed from the URL */
    const q = new URLSearchParams(location.search).get('q');
    if (q && q.trim()) {
      try { history.replaceState(null, '', location.pathname); } catch (e) {}
      this.send(q.trim().slice(0, 500));
    }
  }

  load() { try { return JSON.parse(localStorage.getItem(this.d.key) || '[]'); } catch (e) { return []; } }
  save() { try { localStorage.setItem(this.d.key, JSON.stringify(this.chats.slice(0, 20))); } catch (e) {} }
  panel(open) { this.side.classList.toggle('is-open', open); this.$('.sa__scrim').hidden = !open; }

  newChat() {
    this.current = null;
    this.thread.innerHTML = '';
    this.$('[data-welcome]').hidden = false;
    this.renderHistory();
  }

  open(id) {
    const c = this.chats.find((x) => x.id === id);
    if (!c) return;
    this.current = c;
    this.thread.innerHTML = '';
    this.$('[data-welcome]').hidden = true;
    c.messages.forEach((m) => (m.role === 'user' ? this.addUser(m.text) : this.addBot(m.text, m.products, false)));
    this.renderHistory();
    this.panel(false);
  }

  renderHistory() {
    const ul = this.$('[data-history]');
    ul.innerHTML = '';
    this.chats.forEach((c) => {
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'sa__hbtn'; b.textContent = c.title;
      b.setAttribute('aria-current', !!this.current && this.current.id === c.id);
      b.addEventListener('click', () => this.open(c.id));
      li.append(b); ul.append(li);
    });
  }

  scroll() { const s = this.$('[data-scroll]'); s.scrollTo({ top: s.scrollHeight, behavior: theme.reduce ? 'auto' : 'smooth' }); }

  addUser(text) {
    const li = document.createElement('li');
    li.className = 'sa__msg sa__msg--user';
    const b = document.createElement('div'); b.className = 'sa__bubble'; b.textContent = text;
    li.append(b); this.thread.append(li); this.scroll();
  }

  addBot(text, products = [], stream = true) {
    const li = document.createElement('li');
    li.className = 'sa__msg sa__msg--bot';
    const who = document.createElement('span'); who.className = 'sa__who'; who.textContent = this.$('.sa__bar-title strong').textContent;
    if (this.d.avatar) { const av = document.createElement('img'); av.className = 'sa__avatar sa__avatar--xs'; av.src = this.d.avatar; av.alt = ''; av.width = 24; av.height = 24; who.prepend(av); }
    const b = document.createElement('div'); b.className = 'sa__bubble';
    li.append(who, b); this.thread.append(li);
    const finish = () => { b.textContent = text; if (products.length) li.append(this.cards(products)); this.scroll(); };
    if (!stream || theme.reduce) return finish();
    let i = 0;
    const tick = () => {
      i = Math.min(text.length, i + 3);
      b.textContent = text.slice(0, i);
      this.scroll();
      i < text.length ? setTimeout(tick, 18) : finish();
    };
    tick();
  }

  cards(products) {
    const ul = document.createElement('div');
    ul.className = 'sa__cards';
    products.slice(0, 3).forEach((p) => {
      const c = document.createElement('div'); c.className = 'sa__card';
      if (p.image) { const im = document.createElement('img'); im.src = p.image; im.alt = ''; im.loading = 'lazy'; c.append(im); }
      const a = document.createElement('a'); a.className = 't'; a.href = p.url; a.textContent = p.title;
      const pr = document.createElement('span'); pr.className = 'num'; pr.textContent = theme.money(p.price);
      c.append(a, pr);
      if (p.available && p.single && p.id) {
        const btn = document.createElement('button'); btn.type = 'button'; btn.className = 'btn';
        btn.dataset.quickAdd = p.id; btn.textContent = window.themeStrings.addToCart;
        btn.setAttribute('aria-label', p.title);
        c.append(btn);
      } else {
        const l = document.createElement('a'); l.className = 'btn btn--secondary'; l.href = p.url; l.textContent = '→'; l.setAttribute('aria-label', p.title); c.append(l);
      }
      ul.append(c);
    });
    return ul;
  }

  async send(text) {
    text = (text || this.input.value).trim();
    if (!text) return;
    this.input.value = ''; this.input.style.height = 'auto';
    this.$('[data-welcome]').hidden = true;
    if (!this.current) {
      this.current = { id: String(Date.now()), title: text.slice(0, 48), messages: [] };
      this.chats.unshift(this.current);
    }
    this.current.messages.push({ role: 'user', text });
    this.addUser(text);

    const wait = document.createElement('li');
    wait.className = 'sa__msg sa__msg--bot';
    wait.innerHTML = `<div class="sa__bubble" aria-label="${this.d.labelThinking}"><span class="sa__dots"><i></i><i></i><i></i></span></div>`;
    this.thread.append(wait); this.scroll();

    let answer, products = [];
    try {
      if (this.d.endpoint) {
        const res = await fetch(this.d.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ message: text, history: this.current.messages.slice(-10) }) });
        if (!res.ok) throw new Error();
        const data = await res.json();
        answer = data.answer || this.d.labelNone;
        products = await Promise.all((data.products || []).slice(0, 3).map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
        products = products.filter(Boolean).map((p) => ({ title: p.title, url: p.url, price: p.price, available: p.available, image: p.featured_image, id: p.variants[0]?.id, single: p.variants.length === 1 }));
      } else {
        await new Promise((r) => setTimeout(r, 700));
        answer = this.d.labelDemo || this.d.labelNone;
        products = this.demo.slice(0, 3);
      }
    } catch (e) {
      answer = this.d.labelError;
    }
    wait.remove();
    this.current.messages.push({ role: 'bot', text: answer, products });
    this.save(); this.renderHistory();
    this.addBot(answer, products);
  }
}
customElements.define('skin-assistant', SkinAssistant);
